module.exports = require("core-js/library/fn/object/get-own-property-descriptor");


//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime/core-js/object/get-own-property-descriptor.js
// module id = 262
// module chunks = 168707334958949